<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="newCritereRecherche">
    <div class="column is-12 pdb-0"
         :class="[
      {'hauteur-haut-brief-filtre': errors.length === 0},
      {'hauteur-haut-brief-filtre-errors': errors.length > 0}
    ]">
      <div class="column is-12" v-if="errors.length > 0">
        <error-msg-component :messages="errors"
                             :error="errors.length > 0"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"
                             @close="errors = []"/>
      </div>
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('general.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('general.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless"
         :class="[
           {'hauteur-brief-filtre': errors.length === 0},
           {'hauteur-brief-filtre-errors': errors.length > 0}
         ]">
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeAudit.filtre.code')">
          <qd-taginput v-model="newCritereRecherche.codes" type="is-primary">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeAudit.filtre.titre')">
          <qd-taginput v-model="newCritereRecherche.themes" type="is-primary">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <libelle-tag-input
                        :label="$t('listeAudit.filtre.etat')"
                        :items="constantes.LIST_ETAT_AUDIT"
                        v-model="etatsSelected">
        </libelle-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeAudit.filtre.dateSouhaite')">
          <div class="columns is-vcentered" >
            <b-datepicker show-week-number
                          class="column"
                          icon="calendar-today"
                          :editable="true"
                          v-model="newCritereRecherche.dates.dateDebut"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
            <span class="column is-1">{{$t('general.au')}}</span>
            <b-datepicker show-week-number
                          class="column"
                          icon="calendar-today"
                          :editable="true"
                          v-model="newCritereRecherche.dates.dateFin"
                          position="is-bottom-left"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
          </div>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeAudit.filtre.datePlanification')">
          <div class="columns is-vcentered" >
            <b-datepicker show-week-number
                          class="column"
                          icon="calendar-today"
                          :editable="true"
                          v-model="newCritereRecherche.datesPremierAffichage.dateDebut"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
            <span class="column is-1">{{$t('general.au')}}</span>
            <b-datepicker show-week-number
                          class="column"
                          icon="calendar-today"
                          :editable="true"
                          v-model="newCritereRecherche.datesPremierAffichage.dateFin"
                          position="is-bottom-left"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
          </div>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeAudit.filtre.dateRealisation')">
          <div class="columns is-vcentered" >
            <b-datepicker show-week-number
                          class="column"
                          icon="calendar-today"
                          :editable="true"
                          v-model="newCritereRecherche.datesValidite.dateDebut"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
            <span class="column is-1">{{$t('general.au')}}</span>
            <b-datepicker show-week-number
                          class="column"
                          icon="calendar-today"
                          :editable="true"
                          v-model="newCritereRecherche.datesValidite.dateFin"
                          position="is-bottom-left"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
          </div>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <agence-tag-input
                      :label="$t('listeAudit.filtre.agence')"
                      :items="agencesSelectionnees"
                      v-model="newCritereRecherche.agencesId">
        </agence-tag-input>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{$t('listeOrdreTravailAffichage.filtre.actions.appliquer')}}
      </button>

      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()">
        {{$t('listeOrdreTravailAffichage.filtre.actions.reinitialiser')}}
      </button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import messageErreur from '@/services/general/messageErreur';
import genererCritereRecherche
  from '@/services/logistique/audit/genererObject/genererCritereRecherche';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { LIST_ETAT_AUDIT } from '@/configuration/logistique/audit/auditConf';
import { SET_CRITERES } from '@/store/modules/logistique/audit-mutation-type';
import validationCriteresRecherche
  from '@/services/logistique/audit/validation/validationCritereRecherche';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';
import agenceTagInput from '@/components/general/tagInput/agenceTagInput';

const Parametres = createNamespacedHelpers('parametres');
const Audit = createNamespacedHelpers('audit');
const Societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      newCritereRecherche: null,
      constantes: {
        LIST_ETAT_AUDIT,
      },
      etatsSelected: [],
      errors: [],
    };
  },
  components: {
    libelleTagInput,
    agenceTagInput,
    errorMsgComponent,
  },
  computed: {
    ...Audit.mapGetters({
      critereRechercheFromStore: 'critereRecherche',
    }),
    ...Societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    ...Audit.mapMutations({
      setCritereRecherche: SET_CRITERES,
    }),
    appliquerCritere() {
      this.errors = [];
      validationCriteresRecherche(this.newCritereRecherche, this.errors);
      if (this.errors.length !== 0) return;
      this.newCritereRecherche.otEtat = this.etatsSelected.map(el => { return el.code; });
      this.setCritereRecherche(this.newCritereRecherche);
      this.$emit('recherche', this.newCritereRecherche);
    },
    viderCritere() {
      this.etatsSelected = [];
      this.newCritereRecherche = genererCritereRecherche();
      this.etatsSelected = this.constantes.LIST_ETAT_AUDIT.filter((e) => {
        return this.newCritereRecherche.otEtat.includes(e.code);
      });
    },
    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.loadParametreUtilisateur();
        this.newCritereRecherche = cloneDeep(this.critereRechercheFromStore);
        if (this.newCritereRecherche.otEtat.length > 0) {
          this.etatsSelected = this.constantes.LIST_ETAT_AUDIT.filter((e) => {
            return this.newCritereRecherche.otEtat.includes(e.code);
          });
        }
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};

</script>
